/**
 * Espelha TipoIntegracaoEnum da API RepoDFSe (só código, sem tabela): com qual módulo o documento troca efeito.
 * Serve às letras da listagem de serviços tomados (só Financeiro).
 */
export enum TipoIntegracaoEnum {
  /** Financeiro: contas a pagar ou a receber do documento. */
  Financeiro = 1,
  /** Estoque: movimentação de estoque do documento. */
  Estoque = 2,
}

/**
 * Sigla, nome e cor do indicador de cada tipo de integração. A cor é a variável global da paleta
 * de siglas, pronta para `[style.--indicador-cor]`.
 */
export const TipoIntegracaoIndicador: { [key: number]: { sigla: string; nome: string; cor: string } } = {
  [TipoIntegracaoEnum.Financeiro]: { sigla: 'F', nome: 'Financeiro', cor: 'var(--indicador-cor-f)' },
  [TipoIntegracaoEnum.Estoque]: { sigla: 'E', nome: 'Estoque', cor: 'var(--indicador-cor-e)' },
};
